module.exports = __webpack_public_path__ + "img/9.34595811.png";